module.exports = __webpack_public_path__ + "img/musandaa.688688d1.jpg";